/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { BATTLE_ROOMS_COLUMNS, PLAYERS_COLUMN_DESCRIPTION } from 'containers/BattleRooms/constants'

export const TOOLTIPS = {
    clan: {
        id: 'units_list.columns.tooltips.clan.id',
        title: BATTLE_ROOMS_COLUMNS.clan,
        message: (
            <FormattedMessage
                id='units_list.columns.tooltips.clan.message'
                defaultMessage='Нажмите, чтобы отсортировать отряды по рейтингу, приближенному к вашему личному рейтингу.{newLine}Первыми будут отображаться отряды с минимальным количеством свободных мест.'
                values={{
                    newLine: <br/>,
                }}
            />
        ),
    },
    rating: {
        id: 'units_list.columns.tooltips.rating.id',
        title: BATTLE_ROOMS_COLUMNS.rating,
        message: (
            <FormattedMessage
                id='units_list.columns.tooltips.rating.message'
                defaultMessage='Среднее арифметическое показателей личного рейтинга игроков в отряде.'
            />
        ),
    },
    mode: {
        id: 'units_list.columns.tooltips.mode.id',
        title: BATTLE_ROOMS_COLUMNS.mode,
        message: (
            <FormattedMessage
                id='units_list.columns.tooltips.mode.message'
                defaultMessage='Нажмите, чтобы отсортировать по режиму боёв, для которого собирается отряд.'
            />
        ),
    },
    server: {
        id: 'units_list.columns.tooltips.server.id',
        title: BATTLE_ROOMS_COLUMNS.server,
        message: (
            <FormattedMessage
                id='units_list.columns.tooltips.server.message'
                defaultMessage='Нажмите, чтобы отсортировать по серверу, на котором отряд ведёт бои.'
            />
        ),
    },
    squad: {
        id: 'units_list.columns.tooltips.squad.id',
        title: BATTLE_ROOMS_COLUMNS.squad,
        message: PLAYERS_COLUMN_DESCRIPTION,
    },
    places: {
        id: 'units_list.columns.tooltips.places.id',
        title: BATTLE_ROOMS_COLUMNS.places,
        message: (
            <FormattedMessage
                id='units_list.columns.free_slots_tooltip'
                defaultMessage='Нажмите, чтобы отсортировать по количеству свободных мест в составе отряда.{newLine}Легионеры видят количество свободных мест для легионеров.'
                values={{
                    newLine: <br/>,
                }}
            />
        ),
    },
}


// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/components/TableHeader/tooltips.js